/*
 * IGNITION pin (GARAGE, 22-10-2026) - NEW FILE: assets/ignition-pin.js
 *
 * WHY. Ads land on /collections/<collection>?first=<product handle>, and the theme
 * pins that product first when it renders the page. But Shopify's storefront page
 * cache does not key on ?first= - measured 22-10-2026: a request for
 * ?first=riding-therapy-classic-t-shirt was answered from cache with Life Happens
 * pinned first, and a unique fbclid did not change that. So a visitor can be shown
 * whichever product was pinned the last time the page was rendered.
 *
 * WHAT THIS DOES, in the visitor's browser, after the page has loaded:
 *   1. reads first= from the URL; does nothing without a valid handle
 *   2. if the grid's first card is already that product, does nothing (the
 *      server pinned it - the normal case on a fresh render)
 *   3. if the product's card is further down the page, moves it to the top
 *   4. otherwise fetches its card from /products/<handle>?view=card
 *      (templates/product.card.liquid) and puts it first, removing any copy of
 *      the same product further down
 * It inserts ONLY a card whose data-ignition-pin is the handle it asked for, so a
 * missing template (the fetch then returns a whole product page) or any failure
 * leaves the page exactly as it was served. It never removes any other product.
 */
(function () {
  'use strict';

  var HANDLE = /^[a-z0-9][a-z0-9-]*$/;
  var handle = (new URLSearchParams(window.location.search).get('first') || '').trim().toLowerCase();
  if (!HANDLE.test(handle)) return;

  var grid = document.getElementById('product-grid');
  if (!grid) return;

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var match = link && link.getAttribute('href').match(/\/products\/([a-z0-9][a-z0-9-]*)/);
    return match ? match[1] : null;
  }

  function cards() {
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.matches('li.grid__item');
    });
  }

  function putFirst(card) {
    cards().forEach(function (el) {
      if (el !== card && handleOf(el) === handle) el.remove();   // no duplicate further down
    });
    grid.insertBefore(card, grid.firstElementChild);
  }

  var current = cards();
  if (current.length && handleOf(current[0]) === handle) return;

  var onPage = current.filter(function (el) { return handleOf(el) === handle; })[0];
  if (onPage) {
    putFirst(onPage);
    return;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    })
    .then(function (html) {
      var template = document.createElement('template');
      template.innerHTML = html.trim();
      var card = template.content.querySelector('li[data-ignition-pin]');
      if (!card || card.getAttribute('data-ignition-pin') !== handle) return;
      putFirst(card);
    })
    .catch(function () { /* the page stands as it was served */ });
})();

